import $ from 'cash-dom';
import animate from './animate';

$(function () {
    const $accordion = $('.accordion');

    $accordion.find('.title').on('click', function (e) {
        e.preventDefault();

        const $title = $(this);

        if ($title.hasClass('active')) {
            slideUp($title);
        } else {
            slideUp($accordion.find('.title.active'));
            slideDown($title);
        }
    });

    function slideUp($title) {
        if (!$title || !$title.length) {
            return;
        }

        animate.slideUp($title.next('.accordion-content').get(0), 200);
        $title.removeClass('active');
        $title.find('.arrow i').removeClass('fa-chevron-up').addClass('fa-chevron-down');
    }

    function slideDown($title) {
        if (!$title || !$title.length) {
            return;
        }

        animate.slideDown($title.next('.accordion-content').get(0), 200);
        $title.addClass('active');
        $title.find('.arrow i').removeClass('fa-chevron-down').addClass('fa-chevron-up');
    }
});
